import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { webAdminGuard } from '../shared/guards/web-admin.guard';
import { VJDistSearchComponent } from './vjdist-search/vjdist-search.component';


const routes: Routes = [

  { path:'', component:VJDistSearchComponent
} 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicWebsRoutingModule { }
